import { Error, Loading } from '@organisms/Feedbacks';
import React from 'react';
import styled from 'styled-components';
import { dateFormat, postCodeFormat } from '../Utils';

type Props = {
    listData:any;
    // applyType:string
};

const DetailApplicationInfoClose = (props:Props) => {
    const { listData  } =  props;
    const { data, error, loading } = listData;
    
    return (
        <WrapperWithStyled className='detailTableWrapper'>
            {loading && <Loading />}
            {error && <Error />}
            {data &&
                <table className='table table-bordered table-secondary'>
                    <tbody>
                        <tr>
                            <th className='cell-20per'>ID</th>
                            <td className='cell-30per'>{data.id}</td>
                            <th className='cell-20per'>契約ID</th>
                            <td className='cell-30per'>{data.contactId}</td>
                        </tr>
                        <tr>
                            <th>申込種別</th>
                            <td>{data?.requestCategoryName || (data.requestCategory === '01' ? '廃止' : '撤去')}</td>
                            <th>廃止理由</th>
                            <td>{data.closeCauseName}</td>
                        </tr>
                        <tr>
                            <th>物件管理番号</th>
                            <td>{data.propertyManagementNo}</td>
                            <th>廃止希望日</th>
                            <td>{dateFormat(data.abolitionHopeDate)}</td>
                        </tr>
                        <tr>
                            <th>受付工程</th>
                            <td>{data.acceptStatusName}</td>
                            <th>廃止依頼日</th>
                            <td>{dateFormat(data.abolitionRequestDate)}</td>
                        </tr>
                        <tr>
                            <th>契約者名 カナ</th>
                            <td>{data.contractorNameKana}</td>
                            <th>依頼元システム</th>
                            <td>{data.systemClassName}</td>
                        </tr>
                        <tr>
                            <th>契約者名</th>
                            <td>{data.contractorName}</td>
                            <th>建物解体有無</th>
                            <td>{data.demolitionFlg ? '有' : '無'}</td>
                        </tr>
                        <tr>
                            <th>立ち合い可否</th>
                            <td>{data.witnessFlg ? '有' : '無'}</td>
                            <th>解体予定日</th>
                            <td>{dateFormat(data.demolitionDate)}</td>
                        </tr>
                        <tr>
                            <th>立合希望日</th>
                            <td>{dateFormat(data.witnessDesiredDate)}</td>
                            <th>解体予定時刻</th>
                            <td>{data.demolitionScheduleTime}</td>
                        </tr>
                        <tr>
                            <th>立合希望時刻</th>
                            <td>{data.witnessDesiredTime}</td>
                            <th>電話番号</th>
                            <td>{data.phoneNumber}</td>
                        </tr>
                        <tr>
                            <th>住所</th>
                            <td colSpan={3}>{postCodeFormat(data.zipCode)}　{data.address}</td>
                        </tr>
                        <tr>
                            <th>供給地点特定番号</th>
                            <td colSpan={3}>
                                {data.powerCustomerLocationNumber}
                                {/* <button className='btn btn-primary btn-sm'>供給地点特定番号登録</button> */}
                            </td>
                        </tr>
                    </tbody>
                </table>
            }
        </WrapperWithStyled>
    );
};

const WrapperWithStyled = styled.div`
margin: 0 0 10px;
& td {
    background-color: white;
}
`

export default DetailApplicationInfoClose;